import { FormControl, FormErrorMessage, FormHelperText, FormLabel } from '@chakra-ui/react';
import { Show } from '@pelicargo/ui';
import { ReactNode } from 'react';

import { useFieldValidationStates } from '../hooks/useFieldValidationStates';

export const compareValues = (prev: Readonly<any>, next: Readonly<any>): boolean => {
  const prevValue = prev?.fieldProps?.value;
  const nextValue = next?.fieldProps?.value;

  return prevValue === nextValue;
};

export interface SimpleXProps {
  name: string;
  label?: string;
  placeholder?: string;
  helper?: string;
  children?: ReactNode;
  isRequired?: boolean;
  ignoreOnBlur?: boolean;
  parse?: (value: number) => number;
}

type SimpleFieldProps<InputType> = SimpleXProps & InputType;

export const SimpleField = <InputType,>({ name, label, children, helper, ...rest }: SimpleFieldProps<InputType>) => {
  const { error, isInvalid } = useFieldValidationStates(name as string);

  return (
    <FormControl name={name} id={name as string} isInvalid={isInvalid} {...rest}>
      <Show if={!!label}>
        <FormLabel w="full" fontSize="xs" fontWeight="400">
          {label}
        </FormLabel>
      </Show>
      {children}
      <Show if={!!error?.message}>
        <FormErrorMessage color="error">{error?.message}</FormErrorMessage>
      </Show>
      {helper && <FormHelperText>{helper}</FormHelperText>}
    </FormControl>
  );
};
